<template>
    <div class="container">
      <app-header title="我的需求"/>
      <div class="main">
        <div class="title">
          <div class="text">具体需求内容如下：</div>
          <div class="zhuyi">（真实填写有助于为您提供合适产品）</div>
        </div>
        <div class="tip">注意:填写时务必填写:求购人姓名/联系方式/公司名称</div>
        <!--<van-button type="warning" color="#F1124C" @click="add">添加</van-button>-->
        <div class="table_box_big">
          <div class="table_box">
            <table class="table" border="0" width="100%" cellspacing="10" style="table-layout:fixed">
              <!-- 表头 -->
              <thead>
                <tr>
                  <th>*产品型号</th>
                  <th>*产品名称</th>
                  <th>*产品封装</th>
                  <th>品牌要求</th>
                  <th>接受价格</th>
                  <th>产品数量</th>
                  <th>备注</th>
                  <th>操作</th>
                </tr>
              </thead>
            </table>
            <div class="table_tbody_box">
              <table class="table"  border="0" width="100%" cellspacing="10" style="table-layout:fixed">
                <tbody>
                  <tr v-for="(item,index) in form" :key="index">
                    <td><page-input v-model="item.model" class="input"/></td>
                    <td><page-input v-model="item.name" class="input"/></td>
                    <td><page-input v-model="item.packages" class="input"/></td>
                    <td><page-input v-model="item.brand" class="input"/></td>
                    <td><page-input v-model="item.price" class="input"/></td>
                    <td><page-input v-model="item.number" class="input"/></td>
                    <td><page-input v-model="item.remark" class="input"/></td>
                    <td>
                      <div @click="remove(index)" style="display: flex;flex-direction: row;align-items: center;justify-content: center">
                        <img src="@/assets/del.png" alt="" width="16" height="16">
                        <span style="margin-left: 10px">移除</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="tip">左右滑动查看更多</div>
        <div style="margin: 5px 0">
          <div @click="add" style="width: 30%;display: flex;flex-direction: row;justify-content: center;align-items: center;background: #e2e2e2;padding: 8px;">
            <img src="@/assets/add.png" alt="" width="16" height="16">
            <span style="margin-left: 8px">添加</span>
          </div>
        </div>
      </div>

      <div class="submit" @click="handleShow">提交</div>
      <div class="my-container">
        <van-popup v-model="show" get-container="#my-container" :style="{ height: '400px',width: '90%',borderRadius: '6px' }">
          <div class="content">
            <div><img src="@/assets/close.png" alt="关闭" width="16" height="16" @click="show = false"></div>
            <div class="title">请填写联系人信息，更加方便提供服务！</div>
            <div class="form-item">
              <label for="username">联系人</label>
              <!--<input type="text" id="name">-->
              <page-input v-model="row.username" class="input" id="username"/>
            </div>
            <div class="form-item">
              <label for="phone">联系电话</label>
              <!--<input type="text" id="tel">-->
              <page-input v-model="row.phone" class="input" id="phone"/>
            </div>
            <div class="form-item">
              <label for="company">公司名称</label>
              <!--<input type="text" id="compony">-->
              <page-input v-model="row.company" class="input" id="company"/>
            </div>
            <div class="submit" @click="onSubmit">完成</div>
          </div>
        </van-popup>
      </div>
    </div>
</template>

<script>
import { batchSaveShopPurchase } from '@/api/purchase'
export default {
  name: 'Table',
  data() {
    return {
      show: false,
      items: [],
      row: {
        type: 0,
        uid: '',
        username: '',
        phone: '',
        company: '',
        fileType: 2, // 0-文件(excel&word),1-图片,2-表单列表
        fromType : 0
      },
      form: []
    }
  },
  created() {
    var user = localStorage.getItem('storeInfo')
    if (!user){
      this.$router.push({path: '/business/login'})
      return;
    }
    user = JSON.parse(user)
    this.row.uid = user.id
    this.row.type = this.$route.query.type
    this.add()
  },
  methods: {
    handleShow(){
      if (this.form.length <= 0) {
        this.$toast.fail('请至少输入一条产品信息');
        return;
      }
      for( var i=0; i< this.form.length; i++ ) {
        let temp = this.form[i];
        if (!temp.model) {
          this.$toast.fail('请填写产品型号')
          return
        }
        if (!temp.name) {
          this.$toast.fail('请填写产品名称')
          return
        }
        if (!temp.packages) {
          this.$toast.fail('请填写产品封装/规格')
          return
        }
      }
      this.show = true
    },
    remove(index){
      this.form.splice(index,1)
    },
    add() {
      this.form.push({
        model: undefined, // 型号
        name: undefined, // 名称
        packages: undefined, // 封装
        brand: undefined, // 品牌要求
        price: undefined, // 价格要求
        number: undefined, // 数量
        remark: undefined ,// 产品要求
        fileType: 2
      })
    },
    onSubmit() {
      if (!this.row.username) {
        this.$toast.fail('请填写用户名')
        return
      }
      if (!this.row.phone) {
        this.$toast.fail('请填写手机号码')
        return
      }
      if (!this.row.company) {
        this.$toast.fail('请填写公司名称')
        return
      }
      if (this.$route.query.sid != undefined && this.$route.query.sid != null) {
        this.row['source'] = 1
      }
      const forms = {
        ...this.row,
        purchaseItems: this.form
      }
      batchSaveShopPurchase(forms).then((res) => {
        if (res.success) {
          this.$toast.success('成功')
          this.show = false
          setTimeout(() => {
            this.$router.go(-1)
          },2500)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    width: 100vw;
    height: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-y: scroll;
    padding-bottom: 60px;
    font-size: 14px;
    .main{
      padding: 0 12px;
      .title{
        display: flex;
        margin-top: 15px;
        .text{
          height:22px;
          font-size:16px;
          font-weight:bold;
          line-height:21px;
          color:rgba(51,51,51,1);
        }
        .zhuyi{
          margin-top: 6px;
          height:14px;
          font-size:10px;
          font-weight:400;
          line-height:14px;
          color:rgba(254,0,59,1);
        }
      }
      .tip{
        height:21px;
        font-size:12px;
        font-weight:bold;
        line-height:21px;
        color:rgba(254,0,59,1);
      }
      .table_box_big{
        overflow: scroll;
        width: 100%;
        /*overflow-x: scroll;*/
        /*overflow-y: hidden;*/
        position: relative;
        min-height: 100px;
        height: auto;
      }
      .table_box{
        /*overflow: hidden;*/
        /*position: absolute;*/
      }
      .table_tbody_box{
        /*height: 400px;*/
        /*overflow: scroll;*/
      }
      table thead tr th{
        width:100px;
        height:30px;
        text-align: center;
        word-break: keep-all;
        padding: 2px 10px;
        font-size:13px;
        font-weight:400;
        color:rgba(102,102,102,1);

      }
      table tbody tr td{
        width:100px;
        height:30px;
        line-height: 30px;
        border: 1px solid #eeeeee;
        text-align: center;
        word-break: keep-all;
        padding: 2px 10px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-size:13px;
        font-weight:400;
        color:rgba(102,102,102,1);
        //border:#CCCCCC 1px solid;
        .input{
          width:80px;
          border: none;
          padding: 0;
        }
      }

    }
    .submit{
      position: fixed;
      right: 12px;
      bottom: 12px;
      left: 12px;
      height: 50px;
      line-height: 50px;
      background: #F1124C;
      text-align: center;
      color: #ffffff;
      border-radius: 5px;
    }
    .my-container{
      .content{
        padding: 10px;
        .title{
          height:22px;
          font-size:16px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          text-align: center;
        }
        .form-item{
          display: flex;
          flex-direction: row;
          padding: 0 15px;
          margin-top: 25px;
          label{
            width: 75px;
            height: 40px;
            line-height: 40px;
            display: inline-block;
          }
          .input{
            //height:40px;
            border:1px solid rgba(243,243,243,1);
            border-radius:4px;
            padding: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/business/purchase/table.vue